import { FC } from 'react';
import { ButtonProps, CircularProgress, Button } from '@material-ui/core';

export type Props = {
  loading?: boolean;
  loadingIcon?: React.ReactNode;
} & ButtonProps;

export const LoadingButton: FC<Props> = ({
  children,
  loading = false,
  loadingIcon = <CircularProgress size={'20px'} />,
  disabled,
  ...rest
}) => {
  const _disabled = loading || disabled;
  return (
    <Button {...rest} disabled={_disabled}>
      {loading ? loadingIcon : children}
    </Button>
  );
};

export default LoadingButton;
